// Fullscreen background YouTube video for the hero, matching the reference site.
const VIDEO_ID = "j9rHPBK6yJM";

export default function BackgroundVideo() {
  const src = `https://www.youtube.com/embed/${VIDEO_ID}?autoplay=1&mute=1&controls=0&loop=1&playlist=${VIDEO_ID}&playsinline=1&modestbranding=1&showinfo=0&rel=0&iv_load_policy=3`;
  return (
    <div className="absolute inset-0 overflow-hidden pointer-events-none" data-testid="hero-video">
      <iframe
        title="Black Lemon Studio showreel"
        src={src}
        allow="autoplay; encrypted-media"
        frameBorder="0"
        className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 scale-[1.35]"
        style={{
          width: "max(100vw, 177.78vh)",
          height: "max(56.25vw, 100vh)",
        }}
      />
      {/* overlays: keep left readable, let the video breathe elsewhere */}
      <div className="absolute inset-0 bg-[#09090B]/35" />
      <div className="absolute inset-0 bg-gradient-to-r from-[#09090B] via-[#09090B]/40 to-transparent" />
      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-[#09090B]" />
    </div>
  );
}
